import React from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';

import { mq, black03, green01, green02 } from '../../_style';

import ArticleWrap from '../../components/organisms/articleWrap';
import ArticleBody from '../../components/organisms/articleBody';
import ColumnDetailAside from '../../components/organisms/columnDetail/columnDetailAside';
import ArticleHeader from '../../components/molecules/articleHeader';
import ArticleSection from '../../components/molecules/articleSection';
import ArticleImage from '../../components/atoms/articleImage';
import TextBlock from '../../components/molecules/textBlock';
import Text from '../../components/atoms/text';
import Caption from '../../components/atoms/caption';

const Container = styled.div`
`;
const ListBlock = styled.div`
  margin-bottom: 30px;
  border-radius: 4px;
  border: solid 1px ${green02};
  ${mq.pc} {
    padding: 30px 40px;
  }
  ${mq.sp} {
    padding: 30px 24px;
  }
  li {
    color: ${black03};
    font-size: 16px;
    display: flex;
    &:not(:last-of-type) {
      margin-bottom: 10px;
    }
    &::before {
      border: 1px solid ${green01};
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      margin-top: 8px;
      margin-right: 8px;
    }
  }
`;

const ColumnDetail = (props) => {
  return(
    <Container>
      <Helmet
          title="あなたは大丈夫？歯周病を予防して、生涯健康な歯を保とう！ | お口の健康コラム | モンダミン 公式サイト | アース製薬"
          meta={[
              { name: 'description', content: '歯を失う原因の第１位はむし歯ではなく、歯周病だと言われています。実は歯周病は気付かないうちに進行してしまう恐ろしい病気です。歯周病の症状や、予防方法についてご紹介します。' },
              { name: 'keywords', content: 'マウスウォッシュ,洗口液,液体ハミガキ,液体歯磨き,モンダミン,もんだみん,mondahmin,口臭,口臭ケア,むし歯,歯肉炎,歯周病,歯周炎,オーラルケア,アース製薬' }
          ]}
        >
        <body data-block-header="true" />
      </Helmet>
      <ArticleWrap>
        <ArticleBody>
          <ArticleHeader sub={<>あなたは大丈夫？</>} title={<>歯周病を予防して、<br />生涯健康な歯を保とう！</>} filename={'column/06/img-01.jpg'}>
            歯を失う原因の第１位はむし歯ではなく、歯周病だと言われています。実は歯周病は気付かないうちに進行してしまう恐ろしい病気です。
          </ArticleHeader>
          <ArticleSection heading={<>まずはお口の状態をチェックしてみましょう</>}>
            <TextBlock>
              <ListBlock>
                <ul>
                  <li>歯ぐきが赤くはれている</li>
                  <li>歯ぐきから出血がある</li>
                  <li>口の中がネバネバする</li>
                  <li>口臭がある</li>
                  <li>歯ぐきがやせて歯と歯の間に食べ物がつまりやすい</li>
                  <li>歯が長く伸びてきた</li>
                  <li>歯がぐらつく</li>
                  <li>歯ぐきから膿が出てきたことがある</li>
                </ul>
              </ListBlock>
              <Text>１つでも当てはまれば歯周病の可能性があるので、歯科医院での検診がおすすめです。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>そもそも歯周病って？</>}>
            <TextBlock>
              <Text>歯周病は「歯周病菌」が原因の細菌感染症であり、歯肉炎と歯周炎(＝歯槽膿漏)の総称です。菌は直箸でも人から人にうつると言われています。成人の約８割<sup>＊</sup>は歯周病というデータもあり、歯周病菌は成人にとって身近な口腔内細菌です。</Text>
              <Caption>＊平成23年歯科疾患実態調査(厚生労働省)をもとに推計</Caption>
              <ArticleImage onlyPc filename={'column/06/img-02.jpg'}></ArticleImage>
              <ArticleImage onlySp filename={'column/06/sp/img-02.jpg'}></ArticleImage>
              <Text>歯と歯ぐきの隙間に歯垢が溜まると、この中で歯周病菌が増殖し、歯ぐきに炎症をおこします(＝歯肉炎)。さらに炎症が拡大すると歯槽骨と呼ばれる歯を支える土台となる骨を溶かし始めます(＝歯周炎)。結果、歯がグラグラになり、最後には歯が抜けてしまうこともあります。歯肉炎はホームケアで改善できますが、歯周炎まで進行すると歯科医院での治療が必要となります。一度、歯周炎まで進行すると完全に元の状態に治療することは難しいため、歯周炎に進行させないように日頃からのオーラルケアが大切です。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection heading={<>歯周病をしっかり予防しましょう</>}>
            <TextBlock>
              <ArticleImage filename={'column/06/img-03.jpg'}></ArticleImage>
              <Text>歯周病予防の基本はブラッシングによる歯垢の除去です。さらにフロス等を使用してハブラシでは届かない歯の隙間の歯垢も除去しましょう。また、殺菌成分や抗炎症成分を配合した歯磨き粉や液体ハミガキで、歯周病菌を殺菌すると共に歯ぐきの炎症を予防することも効果的です。いつまでも自分の歯で健康に過ごすために、日頃からしっかりとオーラルケアを行って、歯周病を予防しましょう。</Text>
            </TextBlock>
          </ArticleSection>
        </ArticleBody>
      </ArticleWrap>
      <ColumnDetailAside></ColumnDetailAside>
    </Container>
  );
};
export default ColumnDetail;
